import React, { useRef, useEffect } from 'react';
import lottie from 'lottie-web';
import animationData from "../Assets/animation_lnyyfgjm.json";

function WaveformLottie({ play }) {
  const animationRef = useRef(null);

  useEffect(() => {
    const animationInstance = lottie.loadAnimation({
      container: animationRef.current,
      renderer: 'svg',
      loop: true,
      autoplay: false, // Since we're controlling play state via prop
      animationData: animationData,
    });

    // Play or pause animation based on the "play" prop
    if (play) {
      animationInstance.play();
    } else {
      animationInstance.pause();
    }

    return () => {
      animationInstance.destroy(); // Destroy animation instance on unmount
    };
  }, [play]); // React to changes in the "play" prop

  return (
    <div
      ref={animationRef}
      style={{
        width: '200px',
        height: '200px',
        margin: '0',
        padding: '0',
      }}
    ></div>
  );
}

export default WaveformLottie;
